import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=56869fd6"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56869fd6')) {
      api.createRecord('56869fd6', component.options)
    } else {
      api.reload('56869fd6', component.options)
    }
    module.hot.accept("./Exam.vue?vue&type=template&id=56869fd6", function () {
      api.rerender('56869fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/pages/Exam.vue"
export default component.exports